import { CrudPage } from '@restavo/crud';
import React from 'react';
import { useRestaurantBranchesPage } from 'src/features/restaurantBranches';

const RestaurantBranchesSettings = React.memo(() => {
  const { page, photoViewer } = useRestaurantBranchesPage();
  return (
    <>
      <CrudPage {...page} />
      {photoViewer}
    </>
  );
});

export default RestaurantBranchesSettings;
